// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__zo7M0","input":"Input_input__3PNbO","icon":"Input_icon__1DpGS"};